import { gettext } from '@eventbrite/i18n';
import * as analytics from '@eventbrite/site-analytics';
import {
    GA_CHANGE_PAGE_ACTION,
    GA_SEARCH_CATEGORY,
    SEARCH_EVENT_NAVIGATION,
} from '../../constants/analytics';
import { EventSearch } from '../../types/index';
import { transformSearchBucketContent } from '../../utils/transformation';
import { logDiscoveryRequest } from '../api/analytics';
import { search as searchApi } from '../api/search';
import { updateContent } from './content';
// eslint-disable-next-line import/no-cycle
import { updateSearchLocation } from './location';
// eslint-disable-next-line import/no-cycle
import { updateSearchCriteria } from './search';
import { showErrorNotification } from './ui';

const { trackEventFromState } = analytics;

export const RESET_PAGINATION = 'search/resetPagination';
export const resetPagination = () => ({
    type: RESET_PAGINATION,
});

export const SET_CURRENT_PAGE = 'search/setCurrentPage';
export const setCurrentPage = (futurePage: number | string) => ({
    type: SET_CURRENT_PAGE,
    payload: futurePage,
});

export const GET_FUTURE_PAGE = 'search/getFuturePage';
export const getFuturePage = () => ({
    type: GET_FUTURE_PAGE,
});

export const handleGetPage = (futurePage: number, history: object) => (
    dispatch: Function,
    getState: Function,
) => {
    const state = getState();
    const {
        app: { guestId, publicId },
        search: { eventSearch },
        location: { slug },
        pagination: { currentPage, event },
        admin: { experimentOverride } = {},
        user: { isStaff } = {},
    }: {
        app: {
            guestId?: string;
            publicId?: string;
        };
        search: { eventSearch?: EventSearch };
        location: { slug?: string };
        pagination: {
            currentPage?: number;
            event?: { [key: string]: any };
        };
        admin: { experimentOverride?: object };
        user: { isStaff?: boolean };
    } = state;

    const nonZeroBasedFuturePage = futurePage + 1;

    const newEventSearch = {
        ...eventSearch,
        page: nonZeroBasedFuturePage,
    };

    const gaTrackingData = {
        category: GA_SEARCH_CATEGORY,
        label: `${currentPage}-${futurePage}`,
        action: GA_CHANGE_PAGE_ACTION,
        dimensions: { searchId: '' },
    };

    const searchId = logDiscoveryRequest({
        eventSearch: newEventSearch,
        publicUserId: publicId,
        guestId,
        locationSlug: slug,
        userGenerated: true,
        navigation: SEARCH_EVENT_NAVIGATION,
        action: GA_CHANGE_PAGE_ACTION,
        // variant can be used to track experiments
        variant: '',
    });

    if (searchId) {
        gaTrackingData.dimensions = {
            searchId,
        };
    }

    trackEventFromState(state, gaTrackingData);

    /* If page already in state, return it */
    if (event?.[futurePage]) {
        dispatch(setCurrentPage(futurePage));
        dispatch(updateSearchCriteria(newEventSearch));
        return dispatch(updateSearchLocation(history));
    }

    /* Otherwise trigger loading state, and run search to fetch next page */
    dispatch(getFuturePage());

    return searchApi({
        searchQuery: newEventSearch,
        experimentOverride,
        isStaff,
        history,
    })
        .then((response: any) =>
            dispatch(updateContent(transformSearchBucketContent(response))),
        )
        .then(() => dispatch(setCurrentPage(futurePage)))
        .then(() => dispatch(updateSearchLocation(history)))
        .catch(() => {
            dispatch(
                showErrorNotification(
                    gettext('Error finding events. Please try again'),
                ),
            );

            dispatch(setCurrentPage(currentPage || 0));
        });
};
